module.exports = __webpack_public_path__ + "img/Trashy_White_Icon.9afd6800.png";